import { hashSeed } from "../../../shared/src/rng";
import type { DialogueGlyph } from "../../../shared/src/social/dialogue";
import type { BodyId } from "../../../shared/src/rpg";

/** Stable voice identity, independent of frame rate or how often a player reopens a
 * conversation. Replace the matching manifest sample to author a different timbre. */
export function dialogueVoice(id: string, traits: readonly string[] = [], body: BodyId = "male") {
  const seed = hashSeed(id);
  const timbre = traits.includes("gruff") || traits.includes("weary") ? "low" :
    traits.includes("cheerful") || traits.includes("curious") ? "bright" : "warm";
  // Body supplies the default register; personality still owns the timbre. A
  // gruff female can remain lower than a bright male, with stable individual variety.
  const register = body === "female" ? 1.35 : body === "male" ? 0.95 : 1.1;
  const semitones = ((seed % 401) / 400 - 0.5) * 3;
  return { sample: `dialogue.${timbre}`, rate: register * 2 ** (semitones / 12) };
}

export function dialogueVoiceCue(id: string, traits: readonly string[], char: string, style: DialogueGlyph["style"] = {}, body: BodyId = "male") {
  if (!/[\p{L}\p{N}]/u.test(char)) return null;
  const voice = dialogueVoice(id, traits, body);
  const accent = style.bold ? 0.97 : style.italic ? 0.96 : 1;
  const size = style.size === "large" ? 0.93 : style.size === "small" ? 1.08 : 1;
  return { id: `${voice.sample}${style.bold ? ".bold" : ""}`, rate: voice.rate * accent * size * (0.97 + hashSeed(char) % 7 / 100),
    gain: style.bold ? 1.45 : style.size === "small" || style.italic ? 0.75 : 1 };
}
